document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('a[href*="/products/"]').forEach(function(link) {
    link.addEventListener('click', function() {
      var url = this.href || '';
      var handle = url.split('/products/')[1];
      if (handle) handle = handle.split('?')[0].split('#')[0];
      
      var title = this.querySelector('img') 
        ? (this.querySelector('img').alt || handle)
        : (this.innerText.trim() || handle);

      gtag('event', 'select_item', {
        item_list_name: document.title,
        items: [{
          item_id: handle,
          item_name: title
        }]
      });
    });
  });
});
